/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { AzureCsAccountStore } from 'src/core/stores/AzureCsAccountStore';
import { ServiceKey } from 'src/core/stores/AzureSessionStore';
import { commonDemosMessages } from 'src/languageStudio/appShell/prebuiltDemos/utils/commonDemoMessages';

type UseAuthKeysProps = {
    currentServiceKey: ServiceKey;
    currentResource: AzureCsAccountStore;
};
export const useAuthKeys = (props: UseAuthKeysProps) => {
    const { currentServiceKey, currentResource } = props;
    const { localize } = useLocalization();

    const authorizationHeader = React.useMemo(
        () => ({
            key: currentServiceKey.keyType === 'aadToken' ? 'authorization' : 'Ocp-Apim-Subscription-Key',
            value:
                currentServiceKey.keyType === 'aadToken'
                    ? `Bearer ${currentServiceKey.value}`
                    : currentResource?.keyStrings?.key1 ?? localize(commonDemosMessages.subscriptionKeyCurlPlaceholder)
        }),
        [currentResource?.keyStrings?.key1, currentServiceKey.keyType, currentServiceKey.value]
    );

    return { authorizationHeader };
};
